import Main from "../Main";
import { HistoryStyle } from "./Style";

export default function HabitsHistory() {
    return (
        <Main>
            <HistoryStyle>
                <h2>Histórico</h2>
                <p>Em breve você poderá ver o histórico dos seus hábitos aqui!</p>
            </HistoryStyle>
        </Main>
    )
}